import React, {useEffect, useState} from 'react'
import {Pagination} from '../../../../components/Pagination'
import {ModalBase} from '../../../../components/Modals/ModalBase'
import {useDispatch, useSelector} from 'react-redux'
import {
  gu_lu_OpenModalSucursales,
  gu_lu_SetSucursalesSeleccionadas,
  gu_lu_SetUsuarioSeleccionado,
} from '../../../../actions/gestion-usuario/lista-usuario/listaUsuario.actions'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionsGUListarUsuarios} from '../../../../actions/action-creators'
import {convertStringToNit} from '../../../../utils/strings.utils'

const ModalSignacionSucursales = () => {
  const sucursales = useSelector(
    (state: State) => state.gestionUsuario.listarUsuarios.catalogos.sucursales
  )
  const seleccionado = useSelector(
    (state: State) => state.gestionUsuario.listarUsuarios.usuarioSeleccionado
  )
  const [currentItems, setCurrentItems] = useState<Array<any>>([])
  const [selectAll, setSelectAll] = useState<boolean>(false)
  const [selectedRows, setSelectedRows] = useState<string[]>([])
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionsGUListarUsuarios, dispatch)

  useEffect(() => {
    if (sucursales.length === 0) acciones.gu_lu_getSucursales()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    dispatch(gu_lu_SetSucursalesSeleccionadas(selectedRows))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRows])

  useEffect(() => {
    if (seleccionado?.arraySucursalesAsignadas?.length > 0) {
      setSelectedRows(seleccionado.arraySucursalesAsignadas)
      setSelectAll(seleccionado.arraySucursalesAsignadas.length === sucursales.length)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seleccionado])

  const handleCheckboxChange = (event: any, rowId: string) => {
    // Agrega el id de la fila seleccionada
    if (event.target.checked) setSelectedRows([...selectedRows, rowId])
    // Remueve el id de la fila deseleccionada
    else setSelectedRows(selectedRows.filter((id) => id !== rowId))
  }

  const handleSelectAll = () => {
    const newSelectAll = !selectAll
    setSelectAll(newSelectAll)
    // Si "Seleccionar todos" esta marcado
    if (newSelectAll) setSelectedRows([...sucursales.filter((sucu => sucu?.activo === "true")).map((sucursal: any) => sucursal?.idsucursal)])
    // Si "Seleccionar todos" está desmarcado
    else setSelectedRows([])
  }

  const closeModalAceptarRechazar = () => {
    dispatch(gu_lu_OpenModalSucursales(false))
    dispatch(gu_lu_SetUsuarioSeleccionado(null))
  }

  const asignarDesasignarSucursal = () => {
    if (seleccionado?.flagAsignacion) acciones.gu_lu_AsignarDesasignarSucurales()
    else acciones.gu_lu_AceptarSolicitudUsuario()
  }

  return (
    <ModalBase
      Styles={{minWidth: '25%', maxWidth: '900px', backgroundColor: '#f1f1f1', padding: '2%'}}
    >
      <div>
        <h4 className='h4-titles'>Asignar Documentos/Sucursales</h4>
        <div className='tab-plane mt-16'>
          <table className='ta-cu-table-main-responsive ta-cu-responsive-table-main td-left table-pointer'>
            <thead>
              <tr>
                <td>
                  <label className='w-checkbox' style={{marginLeft: '3%'}}>
                    <input
                      autoComplete='off'
                      type='checkbox'
                      checked={sucursales.length > 0 && selectedRows.length === sucursales.length}
                      onChange={handleSelectAll}
                    />
                    <div className='checkbox__checkmark'></div>
                    <div className='checkbox__body' style={{fontWeight: '400'}}>
                      No. Sucursal
                    </div>
                  </label>
                </td>
                <td>Nombre</td>
                <td>Dirección</td>
                <td>NIT</td>
              </tr>
            </thead>
            <tbody>
              {
                currentItems.length === 0 && (
                  <tr>
                    <td colSpan={4} style={{textAlign: 'center', padding: '20px 0px'}}>No hay sucursales activas para asignar al usuario</td>
                  </tr>
                )
              }
              {currentItems.map((element, index) => (
                <tr key={index}>
                  <td data-label='No. Sucursal' onClick={(e) => e.stopPropagation()}>
                    <label className='w-checkbox' style={{marginLeft: '3%'}}>
                      <input
                        autoComplete='off'
                        type='checkbox'
                        checked={selectedRows.includes(element?.idsucursal)}
                        onChange={(e) => {
                          handleCheckboxChange(e, element?.idsucursal)
                        }}
                      />
                      <div className='checkbox__checkmark'></div>
                      <div className='checkbox__body fw-400'>{index + 1}</div>
                    </label>
                  </td>
                  <td data-label='Nombre'>{element.nombre}</td>
                  <td data-label='Dirección'>{element.direccion}</td>
                  <td data-label='NIT'>{convertStringToNit(String(element.nit))}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {
            <Pagination
              data={sucursales.filter((sucu) => sucu.activo === "true" && sucu.eliminado !== "1")}
              state={(items: Array<any>) => setCurrentItems(items)}
              items={15}
            />
          }
        </div>
      </div>
      <br />
      <div className='w-layout-hflex button-actions'>
        <button
          type='button'
          className='m button transparent w-inline-block'
          onClick={closeModalAceptarRechazar}
        >
          Cancelar
        </button>
        <button
          type='button'
          disabled={sucursales.filter((sucu) => sucu.activo === "true" && sucu.eliminado !== "1").length === 0}
          className='m button w-inline-block'
          onClick={asignarDesasignarSucursal}
        >
          Confirmar
        </button>
      </div>
    </ModalBase>
  )
}

export default ModalSignacionSucursales
